import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../styles/cookiebanner.css";

const CONSENT_KEY = "cookieConsent";
const CONSENT_VERSION = "v1";

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    try {
      const stored = JSON.parse(localStorage.getItem(CONSENT_KEY) || "null");
      if (!stored || stored.version !== CONSENT_VERSION) {
        setIsVisible(true);
      }
    } catch {
      setIsVisible(true);
    }
  }, []);

  const save = (value) => {
    localStorage.setItem(
      CONSENT_KEY,
      JSON.stringify({ value, version: CONSENT_VERSION, ts: Date.now() }),
    );
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div
      className="cookie-banner"
      role="dialog"
      aria-live="polite"
      aria-label="Süti hozzájárulás"
    >
      <div className="cookie-inner">
        <p className="cookie-text">
          A weboldal működéséhez és a felhasználói élmény javításához sütiket
          használunk.{" "}
          <Link to="/adatvedelmi-tajekoztato" className="cookie-link">
            Részletek az adatkezelésről
          </Link>
          .
        </p>

        <div className="cookie-buttons">
          <button
            className="cookie-btn cookie-btn-secondary"
            onClick={() => save("declined")}
          >
            Elutasítom
          </button>
          <button
            className="cookie-btn cookie-btn-primary"
            onClick={() => save("accepted")}
          >
            Elfogadom
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
